import React from 'react';
import PropTypes from 'prop-types';
import Svg, { G, Path, Circle } from '@dbk/ui-svg';
import { pure } from '@dbk/ui-react-utils';

function EditIcon(props) {
  const {
    color,
    ...svgProps,
  } = props;

  return (
    <Svg
      {...svgProps}
      viewBox="0 0 32 32"
    >
    <G id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <G id="A4" transform="translate(-77.000000, -41.000000)">
            <G id="Group-5-Copy-5" transform="translate(78.000000, 42.000000)">
                <G id="Group-2-Copy" strokeWidth="1.5" stroke={color}>
                    <G id="Group-Copy-2">
                        <Circle id="Oval" cx="15" cy="15" r="15"></Circle>
                    </G>
                </G>
                <Path d="M21.2534028,7.74659888 C20.2554757,6.75113407 18.6401262,6.75113407 17.6421992,7.74659888 L8.7653405,16.6234575 C8.74155441,16.6469069 8.72034316,16.6728317 8.70206828,16.7007903 L8.6903512,16.7242244 C8.67771768,16.7452055 8.66674815,16.7671446 8.65754338,16.7898401 L8.65754338,16.7898401 L7.02652605,21.3759046 C6.96675575,21.5459722 7.00982059,21.7352478 7.13728721,21.8627144 C7.26475383,21.9901811 7.45402945,22.0332459 7.62409706,21.9734756 L12.2031313,20.3471451 L12.2031313,20.3471451 C12.2249542,20.3385869 12.2461043,20.3284035 12.2664036,20.3166807 L12.2898377,20.3049636 C12.3177962,20.2866887 12.3437211,20.2654775 12.3671704,20.2416914 L20.4800756,12.1311297 L20.4800756,12.1311297 L21.2510594,11.3601459 C22.2487312,10.3625958 22.24978,8.74544212 21.2534028,7.74659888 Z M12.0437791,19.2410529 L9.75660534,16.9538792 L17.201637,9.51353432 L19.4888107,11.800708 L12.0437791,19.2410529 Z M9.2879222,17.8115693 L11.1884323,19.7120794 L8.23807197,20.7619297 L9.2879222,17.8115693 Z M20.5925595,10.6969592 L20.1519974,11.1375214 L17.8648237,8.85034767 L18.3030424,8.40744211 C18.9352751,7.77520942 19.9603268,7.77520943 20.5925595,8.40744212 C21.2247922,9.03967482 21.2247922,10.0647265 20.5925595,10.6969592 Z" id="Shape" fill={color} fillRule="nonzero"></Path>
            </G>
        </G>
    </G>
    </Svg>
  );
}

EditIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
};

EditIcon.defaultProps = {
  height: 32,
  width: 32,
};

export default pure(EditIcon);
